<template>
  <div class="container-fluid" style="padding:0;overflow-x:hidden">
    <div class="row g-1" v-if="layout.type == 'wide'"> 
      <div class="col-md-4" style="height: 640px">
        <ProswComp :dispobj="disp[0]" screensize="2x1" globid="31" />
      </div>

      <div class="col-md-8" style="height: 640px">
        <div class="row g-1">
          <div style="height: 320px">
            <ProswComp :dispobj="disp[1]" screensize="1x2" globid="32" />
          </div>    
        </div>
        <div class="row g-1">
          <div style="height: 320px">
            <ProswComp :dispobj="disp[2]" screensize="1x2" globid="33"/>
          </div>    
        </div>
      </div>
    </div>

    <div class="row" v-if="layout.type == 'long'"> 
      <div class="col-md-4" style="height: 640px">
        <ProswComp :dispobj="disp[0]" screensize="2x1" globid="34"/>
      </div>
      <div class="col-md-4" style="height: 640px">
        <ProswComp :dispobj="disp[1]" screensize="2x1" globid="35"/>
      </div>
      <div class="col-md-4" style="height: 640px">
        <ProswComp :dispobj="disp[2]" screensize="2x1" globid="36"/>
      </div>
    </div>

  <!-- long   0 2 2
              1 2 2 -->
    <div class="row g-1" v-if="layout.type == 'longs'"> 
      <div class="col-md-4" style="height: 640px">
          <div style="height: 320px">
            <ProswComp :dispobj="disp[0]" screensize="1x1" globid="37"/>
          </div>
          <div style="height: 320px">
            <ProswComp :dispobj="disp[1]" screensize="1x1" globid="38"/>
          </div>
      </div>
      <div class="col-md-8" style="height: 640px">
        <ProswComp :dispobj="disp[2]" screensize="2x2" globid="39"/>
      </div>
    </div>
  </div>
</template>

<script>
import ProswComp from './ProswComp.vue' 

export default {
  name: 'LayoutDisp3',
  components: {
      ProswComp
  },
  computed:  {
    disp() {
       return this.$store.state.rootel.dispmaps (this.layout) ;
    }
  },
  props: {
    layout: Object
  }
}
// vim:expandtab:smartindent:tabstop=2:softtabstop=2:shiftwidth=2:
</script>


